import type { ReactNode } from 'react'
import { Loader2 } from 'lucide-react'
import { SettingsPageContainer, SettingsPageHeader } from '@/components/app/layout'

type Props = {
  title: ReactNode
  description?: ReactNode
  /** Right-aligned header slot (e.g. a primary action). */
  action?: ReactNode
  children: ReactNode
}

/**
 * One layout for every settings page (design 15): a fixed left gutter, a
 * 720px column, a large title and a one-line description. Sections stack
 * below with consistent spacing.
 */
export function SettingsPage({ title, description, action, children }: Props) {
  return (
    <SettingsPageContainer>
      <SettingsPageHeader
        title={title}
        description={description}
        action={action}
      />
      <div className="flex flex-1 flex-col gap-7">{children}</div>
    </SettingsPageContainer>
  )
}

/**
 * Loading placeholder that sits in the same column as the loaded page, so
 * the spinner doesn't flash in the middle of the screen before the content
 * snaps to the left gutter.
 */
export function SettingsPageLoading() {
  return (
    <SettingsPageContainer>
      <Loader2 className="size-6 animate-spin text-muted-foreground" />
    </SettingsPageContainer>
  )
}
